export const UOM_ABBREVIATIONS = {
    ea: 'Each',
    oz: 'Ounce',
    fz: 'Fluid Ounce',
    lb: 'Pound',
    ct: 'Count',
    ml: 'Milliliter',
    lt: 'Liter',
    in: 'Inch',
    ga: 'Gallon',
    pt: 'Pint',
    qt: 'Quart',
    pr: 'Pair',
    gr: 'Grams',
    st: 'Stem',
    rl: 'Roll',
    hg: 'Half gallon',
    pk: 'Pack',
    pc: 'Piece',
    sf: 'Square Feet',
    cf: 'Cubic Feet',
    yd: 'Yards',
    dz: 'Dozen',
    bg: 'Bag',
    ft: 'Feet',
    bu: 'Bunch',
    kg: 'Kilograms',
    fl: 'Fluid Ounce',
    bx: 'Box',
    ca: 'Centare',
    ci: 'Cigar',
    mr: 'Meter',
    cg: 'Cigarettes',
    cl: 'Centiliter',
    bl: 'Barrell',
    sh: 'Sheets',
    g: 'Grams',
    mg: 'Milligrams',
    mcg: 'Micrograms',
    cal: 'Calories',
    kcal: 'Kilocalories',
    floz: 'fluid ounces',
};
